export default "__VITE_ASSET__CqZh9DQQ__"